export default {
    all: 'Tous les documents',
    empty: 'Aucun document ne correspond à votre recherche.',
    minus: 'Voir moins -',
    page: 'Documents de référence',
    plus: 'Voir plus +',
    view: 'Consulter le document'
}